import { langcodes } from "#nuxt-language-negotiation/config";
export function isValidLanguage(arg) {
  return typeof arg === "string" && langcodes.includes(arg);
}
